module.exports = __webpack_public_path__ + "static/media/measurements_a_day_icon.469c46e7.svg";